import { Routes } from "@/constants"; 
import { Translations } from "@/translations";
import { ActiveRoleType, AgeGroupType, WorkspaceType } from "@/interFace/general";

interface MenuItem {
  id: number;
  hasDropdown?: boolean;
  active?: boolean;
  title: string;
  pluseIncon?: boolean;
  link: string;
  submenus?: any[];
  pages?: boolean;
  isAuth?: boolean;
  shouldUseUsername?: boolean;
  isProfile?: boolean;
  isInbox?: boolean;
  isBookings?: boolean;
  hasPlayMenu?: boolean;
  iconClass?: string;
  translationNamespace?: "Menu" | "Inbox";
}

const inboxSubmenus = [
  { title: Translations.Inbox.Messages, link: Routes.INBOX, translationNamespace: "Inbox" as const },
  { title: Translations.Inbox.Invitations, link: Routes.FRIENDS, translationNamespace: "Inbox" as const },
  { title: Translations.Inbox.Contacts, link: Routes.CONTACTS, translationNamespace: "Inbox" as const },
];

const profileSubmenus = [
  { title: Translations.Menu.Profile, link: Routes.PROFILE },  
  {
    title: Translations.Menu.How_It_Works,
    link: Routes.HOW_TO,
  },
  { title: Translations.Menu.Log_Out, link: Routes.LOGOUT },
];

const studentWorkspaceMenuData: MenuItem[] = [
  {
    id: 1,
    hasDropdown: false,
    title: Translations.Menu.MyLearning,
    link: Routes.DASHBOARD_COURSES,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 2,
    hasDropdown: false,
    title: Translations.Menu.QuizLibrary,
    link: Routes.QUIZZES,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 3,
    hasDropdown: false,
    title: Translations.Menu.Play,
    link: Routes.PLAY,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: true,
  },
  {
    id: 4,
    hasDropdown: false,
    title: Translations.Menu.Bookings,
    link: Routes.Bookings,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    isBookings: true,
    hasPlayMenu: false,
  },
  {
    id: 5,
    hasDropdown: true,
    title: Translations.Menu.Inbox,
    link: Routes.INBOX,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    isInbox: true,
    hasPlayMenu: false,
    submenus: inboxSubmenus,
  },
  {
    id: 100,
    hasDropdown: true,
    title: "PROFILE_NAME",
    link: Routes.PROFILE,
    isAuth: true,
    shouldUseUsername: true,
    isProfile: true,
    isInbox: false,
    hasPlayMenu: false,
    submenus: profileSubmenus,
  },
];

const tutorProfileSubmenus = [
  { title: Translations.Menu.Profile, 
    link: Routes.PROFILE 
  },
  {
    title: Translations.Menu.How_It_Works,
    link: Routes.HOW_TO,
  },
  {
    title: Translations.Menu.Play,
    link: Routes.PLAY,
  },
  { title: Translations.Menu.Log_Out, 
    link: Routes.LOGOUT 
  }
];

const parentProfileSubmenus = [
  {
    title: Translations.Menu.Profile,
    link: Routes.PROFILE,
  },
  {
    title: Translations.Menu.How_It_Works,
    link: Routes.HOW_TO,
  },
  {
    title: Translations.Menu.Log_Out,
    link: Routes.LOGOUT,
  },
];

const claimantProfileSubmenus = [
  {
    title: Translations.Menu.Profile,
    link: Routes.PROFILE,
  },
  {
    title: Translations.Menu.Education_Providers_FAQ,
    link: Routes.Education_Providers_FAQ,
  },
  {
    title: Translations.Menu.Log_Out,
    link: Routes.LOGOUT,
  },
];


const tutorWorkspaceMenuData: MenuItem[] = [
  {
    id: 6,
    hasDropdown: false,
    title: Translations.Menu.Education_Provider_Discovery,
    link: Routes.Education_Provider_Discovery,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
    iconClass: "bi bi-house-door",
  },
  {
    id: 2,
    hasDropdown: false,
    title: Translations.Menu.Teaching,
    link: Routes.TUTORS_ROOT,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 3,
    hasDropdown: false,
    title: Translations.Menu.QuizLibrary,
    link: Routes.QUIZZES,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 4,
    hasDropdown: false,
    title: Translations.Menu.Bookings,
    link: Routes.Bookings,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    isBookings: true,
    hasPlayMenu: true,
  },
  {
    id: 5,
    hasDropdown: true,
    title: Translations.Menu.Inbox,
    link: Routes.INBOX,
    isAuth: true,
    shouldUseUsername: false,
    isInbox: true,
    hasPlayMenu: false,
    submenus: inboxSubmenus,
  },
  {
    id: 100,
    hasDropdown: true,
    title: "PROFILE_NAME",
    link: Routes.PROFILE,
    isAuth: true,
    shouldUseUsername: true,
    isProfile: true,
    isInbox: false,
    hasPlayMenu: false,
    submenus: tutorProfileSubmenus,
  },
];

const parentWorkspaceMenuData: MenuItem[] = [
  {
    id: 1,
    hasDropdown: false,
    title: Translations.Menu.ParentHub,
    link: Routes.PARENTS_ROOT,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 2,
    hasDropdown: false,
    title: Translations.Menu.Children,
    link: Routes.PARENTS_CHILDREN,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 3,
    hasDropdown: false,
    title: Translations.Menu.QuizLibrary,
    link: Routes.QUIZZES,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 4,
    hasDropdown: true,
    title: Translations.Menu.Inbox,
    link: Routes.INBOX,
    isAuth: true,
    shouldUseUsername: false,
    isInbox: true,
    hasPlayMenu: false,
    submenus: inboxSubmenus,
  },
  {
    id: 100,
    hasDropdown: true,
    title: "PROFILE_NAME",
    link: Routes.PROFILE,
    isAuth: true,
    shouldUseUsername: true,
    isProfile: true,
    hasPlayMenu: false,
    submenus: parentProfileSubmenus,
  },
];

const claimantWorkspaceMenuData: MenuItem[] = [
  {
    id: 1,
    hasDropdown: false,
    title: Translations.General.Dashboard,
    link: Routes.CLAIMANT_ROOT,
    isAuth: true,
    shouldUseUsername: false,
    isProfile: false,
    hasPlayMenu: false,
  },
  {
    id: 100,
    hasDropdown: true,
    title: "PROFILE_NAME",
    link: Routes.PROFILE,
    isAuth: true,
    shouldUseUsername: true,
    isProfile: true,
    hasPlayMenu: false,
    submenus: claimantProfileSubmenus,
  },
];

const studentAuthMenuData: MenuItem[] = studentWorkspaceMenuData;
const creatorAuthMenuData: MenuItem[] = tutorWorkspaceMenuData;

const applyStudentAgeGate = (
  menuData: MenuItem[],
  ageGroup?: AgeGroupType | null
): MenuItem[] => {
  if (ageGroup === "16plus") {
    return menuData;
  }

  return menuData.filter((item) => item.link !== Routes.QUIZZES);
};

export const getAuthMenuByRole = (
  activeRole: ActiveRoleType,
  ageGroup?: AgeGroupType | null
): MenuItem[] => {
  if (activeRole === "teacher" || activeRole === "tutor" || activeRole === "admin") {
    return creatorAuthMenuData;
  }

  if (activeRole === "claimant") {
    return claimantWorkspaceMenuData;
  }

  return applyStudentAgeGate(studentWorkspaceMenuData, ageGroup);
};

export const getAuthMenuByWorkspace = (
  activeWorkspace: WorkspaceType | null,
  activeRole: ActiveRoleType,
  ageGroup?: AgeGroupType | null
): MenuItem[] => {
  if (activeWorkspace === "tutor") {
    return tutorWorkspaceMenuData;
  }

  if (activeWorkspace === "parent") {
    return parentWorkspaceMenuData;
  }

  if (activeWorkspace === "student") {
    return applyStudentAgeGate(studentWorkspaceMenuData, ageGroup);
  }

  if (activeWorkspace === "claimant") {
    return claimantWorkspaceMenuData;
  }

  return getAuthMenuByRole(activeRole, ageGroup);
};

export {
  studentWorkspaceMenuData,
  tutorWorkspaceMenuData,
  parentWorkspaceMenuData,
  claimantWorkspaceMenuData,
  studentAuthMenuData,
  creatorAuthMenuData,
};

export default studentWorkspaceMenuData;

